import { render, staticRenderFns } from "./VendorSummary.vue?vue&type=template&id=42600fc0"
import script from "./VendorSummary.vue?vue&type=script&lang=js"
export * from "./VendorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports